import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

/*
export const MuiCheckBoxes = ()=>{
    return <h1>123</h1>
}*/

export const MuiCheckBoxes = ({array,config,objetoDinamico})=> {
  return (
    <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      options={array}
      disableCloseOnSelect
      onChange={(e, nv) => {
            config.callback(nv)
    }}
    onInputChange={(event, newInputValue) => {
            console.log('e.target',event.target)
            console.log('onInputChange',newInputValue)
    }}
      getOptionLabel={(option) => option[config.option.add]}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option[config.option.label]}
        </li>
      )}
      style={{ width: 500 }}
      renderInput={(params) => (
        <TextField {...params} label={config.label} placeholder={config.placeholder} />
      )}
    />
  );
}

